
import { mapGetters } from 'vuex';

export default {
  name: 'AppMediaCountIcon',
  props: {
    mediaCount: {
      type: Number,
      required: true
    },
    showMediaCountText: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: null,
      validator: v => v === null || v === 'responsive'
    },
    iconSize: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters('widget', ['isMobileViewport']),
    resolvedIconSize() {
      if (this.iconSize) return this.iconSize;
      if (this.size === 'responsive') return this.isMobileViewport ? 20 : 24;
      return null;
    },
    iconName() {
      if (this.resolvedIconSize === 20) return 'ic-media-20px';
      if (this.resolvedIconSize === 24) return 'ic-media-24px';
      return 'icon-page';
    }
  }
};
